var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "EmployeeRemovedFromCompanyTooltip",
    { attrs: { disabled: !_vm.employeeRemoved } },
    [
      _c("ItemChip", {
        attrs: {
          itemId: _vm.userId,
          itemName: _vm.fullName,
          avatar: _vm.userAvatar,
          routeParams: _vm.routeParams,
          removed: _vm.employeeRemoved,
          isPerson: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }